import Card from './components/card'
import Logo from './components/logo'
import Header from './components/header'
import Barcode from './components/barcode'
import HeroImage from './components/hero-image'
import Fields from './components/fields'

const GoogleGiftFront = () => {
  return (
    <Card >
      <Logo />
      <div className="inset giftCard">
        <Header />
        <Fields/>
      </div>
      <Barcode />
      <HeroImage />
    </Card>
  )
}

export default GoogleGiftFront